<div class="admin-layout background-colour flex flex-row">
    <!-- Screen Reader Announcer -->
    <app-sr-announcer></app-sr-announcer>
    
    <!-- Skip Navigation Link for Keyboard Users -->
    <a href="#main-content" class="skip-link" i18n>Skip to main content</a>
    
    <!-- Side Bar Drawer -->
    <p-drawer 
        #drawerRef 
        [(visible)]="isVisibleDrawer" 
        (onShow)="onDrawerShow()"
        [attr.aria-label]="'Navigation menu'"
        role="navigation">
        <ng-template #headless>
            <div class="flex flex-col h-full min-h-0">
                
                <div class="flex items-center justify-between px-6 pt-4 shrink-0">
                    <span class="inline-flex items-center gap-2">
                        <img src="assets/logo-long.png" alt="Office Global Logo" class=" h-[48px]" i18n-alt>
                    </span>
                    <span>
                        <p-button 
                            type="button" 
                            (click)="closeCallback($event)" 
                            icon="pi pi-times" 
                            rounded="true" 
                            outlined="true" 
                            styleClass="h-8 w-8"
                            appGlobalLoadingDisable
                            [attr.aria-label]="'Close navigation menu'"></p-button>
                    </span>
                </div>
                <nav class="admin-layout-sidebar flex-1 overflow-y-auto py-4" aria-label="Main navigation" i18n-aria-label>
                    <div class="p-2">
                    <app-subscription-selector *ngIf="showSubscriptionSelector" [showSelector]="true" (subscriptionChanged)="onSubscriptionChanged($event)" class="md:hidden">
                    </app-subscription-selector>
                    </div>
                    
                    <!-- Menu Loader -->
                    <div *ngIf="isLoadingMenu" class="flex flex-col justify-center items-center py-8">
                        <p-progressSpinner 
                            [style]="{'width': '30px', 'height': '30px'}" 
                            strokeWidth="3"
                            fill="transparent" 
                            animationDuration="1s">
                        </p-progressSpinner>
                        <span class="ml-3 text-sm text-gray-600" i18n>Loading menu...</span>
                    </div>
                    
                    <!-- Menu Items -->
                    <p-menu *ngIf="!isLoadingMenu" [model]="drawerItems" styleClass="w-full border-0">
                    </p-menu>
                    
                </nav>
                <div class="mt-auto">
                    <hr class="mb-4 mx-4 border-t border-0 border-surface" role="separator" />
                    <div class="mx-4 mb-4 flex flex-row gap-2 items-center">
                        <p class="text-[0.875rem] mr-2 font-semibold" aria-label="Application version" i18n-aria-label i18n>Version {{version}}</p>
                        <span 
                            class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium text-white" 
                            [ngClass]="getRoleBasedColor(loggedInUserRole)"
                            role="status"
                            [attr.aria-label]="'Your role: ' + (loggedInUserRoleName || getRoleName(loggedInUserRole) || loggedInUserRole)">
                            {{ loggedInUserRoleName || getRoleName(loggedInUserRole) || loggedInUserRole }}
                        </span>
                    </div>

                </div>
            </div>
        </ng-template>
    </p-drawer>
    <!-- Side Bar -->
    <aside 
        *ngIf="isVisibleSidebar" 
        @fadeSlideInOut 
        class="fixed top-0 left-0 h-[100dvh] min-w-[300px] p-2 flex flex-col overflow-hidden"
        role="navigation"
        aria-label="Main navigation">
        <p-card class="w-full flex-1 min-h-0 admin-fixed-sidebar-card">
            <div class="flex flex-col justify-between h-full min-h-0">
                <div class="flex items-center justify-between shrink-0">
                    <span class="inline-flex items-center gap-2">
                        <img src="assets/logo-long.png" alt="Office Global Logo" class=" h-[58px]">
                    </span>
                </div>
                <nav class="admin-layout-sidebar flex-1 overflow-y-auto py-4" aria-label="Primary navigation">
                    <!-- Menu Loader -->
                    <div *ngIf="isLoadingMenu" class="flex flex-col justify-center items-center py-8">
                        <p-progressSpinner 
                            [style]="{'width': '30px', 'height': '30px'}" 
                            strokeWidth="3"
                            fill="transparent" 
                            animationDuration="1s">
                        </p-progressSpinner>
                        
                    </div>
                    
                    <!-- Menu Items -->
                    <p-menu *ngIf="!isLoadingMenu" [model]="items" styleClass="w-full border-0">
                    </p-menu>
                </nav>
            </div>
        </p-card>
        <p-card class="max-w-[300px] mt-2">
            <div class="flex flex-row flex-wrap gap-3 items-center">
                <p-button 
                    (click)="isVisibleSidebar = false" 
                    icon="pi pi-window-minimize"
                    appGlobalLoadingDisable
                    [attr.aria-label]="'Minimize sidebar'"
                    [attr.aria-expanded]="true" />
                <p class="text-[0.875rem] mr-2 font-semibold" aria-label="Application version">Version {{version}}</p>
                <span 
                    class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium text-white" 
                    [ngClass]="getRoleBasedColor(loggedInUserRole)"
                    role="status"
                    [attr.aria-label]="'Your role: ' + (loggedInUserRoleName || getRoleName(loggedInUserRole) || loggedInUserRole)">
                    {{ loggedInUserRoleName || getRoleName(loggedInUserRole) || loggedInUserRole }}
                </span>
            </div>
        </p-card>
    </aside>

    <div *ngIf="!isVisibleSidebar" @fadeSlideInOut class="fixed bottom-2 left-2 hidden md:flex z-50">
        <p-card class="max-w-[300px] mt-2">
            <div class="flex flex-row gap-3 items-center">
                <p-button 
                    (click)="isVisibleSidebar = true" 
                    icon="pi pi-window-maximize"
                    appGlobalLoadingDisable
                    [attr.aria-label]="'Expand sidebar'"
                    [attr.aria-expanded]="false" />
            </div>
        </p-card>
    </div>

    <div @fadeSlideInOutSlow class="w-full p-2 flex flex-col">
        <!-- Top Bar -->
        <header 
            [ngClass]="{'pl-[303px]': isVisibleSidebar, 'w-full': !isVisibleSidebar}" 
            class="fixed top-0 right-0 z-50 p-2"
            role="banner">
            <p-card class="w-full">
                <div class="flex flex-row justify-between items-center">
                    <div class="flex items-center gap-4">
                        <div *ngIf="!isVisibleSidebar" class="flex flex-row gap-5">
                            <p-button 
                                (click)="isVisibleDrawer = true" 
                                icon="pi pi-bars"
                                appGlobalLoadingDisable
                                [attr.aria-label]="'Open navigation menu'"
                                [attr.aria-expanded]="isVisibleDrawer" />
                            <span class="inline-flex items-center">
                                <img src="assets/logo-flat.png" alt="Office Global Logo" class="md:h-[28px]">
                            </span>
                        </div>

                        <!-- Subscription Selector for High-Level Users -->
                        <app-subscription-selector *ngIf="showSubscriptionSelector" [showSelector]="true" (subscriptionChanged)="onSubscriptionChanged($event)" class="hidden md:block">
                        </app-subscription-selector>
                    </div>

                    <!-- User info -->
                    <div class="flex flex-row items-center gap-3 relative">
                        <!-- Refresh Button -->
                        <p-button 
                            (click)="refreshPage()" 
                            icon="pi pi-refresh"
                            [rounded]="true"
                            [text]="true"
                            appGlobalLoadingDisable
                            [attr.aria-label]="'Refresh page'"
                            [pTooltip]="'Refresh page'"
                            tooltipPosition="bottom">
                        </p-button>
                        
                        <!-- Notification Bell -->
                        <app-notification-panel></app-notification-panel>
                        
                        <div class="flex flex-col items-end hidden md:flex">
                            <div class="flex flex-col">
                                <p class="text-[0.875rem] mr-2 font-semibold" [attr.aria-label]="'Logged in as ' + loggedInUserFirstName + ' ' + loggedInUserLastName">{{ loggedInUserFirstName }} {{ loggedInUserLastName }}</p>
                                <p class="text-[0.875rem] mr-2 font-normal text-[#6B7280]" [attr.aria-label]="'Email: ' + loggedInUserEmail">{{ loggedInUserEmail }}</p>
                            </div>
                            <div class="flex items-center gap-2">
                               
                                <!-- <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium text-white" [ngClass]="getRoleBasedColor(loggedInUserRole)">
                                    {{ getRoleName(loggedInUserRole) || loggedInUserRole }}
                                </span> -->
                            </div>
                        </div>
                        <div class="relative user-dropdown-container">
                            <button
                                type="button" 
                                class="w-11 h-11 flex items-center justify-center rounded-full text-white cursor-pointer hover:opacity-80 transition-opacity" 
                                [ngClass]="getRoleBasedColor(loggedInUserRole)" 
                                (click)="toggleUserDropdown()"
                                [attr.aria-label]="'User menu for ' + loggedInUserFirstName + ' ' + loggedInUserLastName"
                                [attr.aria-expanded]="isUserDropdownOpen"
                                [attr.aria-haspopup]="true">
                                {{ getUserInitials() }}
                            </button>

                            <!-- Dropdown Menu -->
                            @if (isUserDropdownOpen) {
                            <nav 
                                class="absolute right-0" 
                                (click)="$event.stopPropagation()" 
                                styleClass="w-48"
                                role="menu"
                                aria-label="User menu">
                                <div class="py-1">
                                    <p-menu [model]="navigationItems" />
                                </div>
                            </nav>
                            }
                        </div>
                    </div>
                </div>
            </p-card>
        </header>

        <!-- Main Content -->
        <div [ngClass]="{'pl-[295px]': isVisibleSidebar, '': !isVisibleSidebar}">
            <main class="pt-18 min-h-screen pl-2" id="main-content" tabindex="-1">
                <router-outlet></router-outlet>
            </main>
        </div>
    </div>

</div>

<!-- Global Toast Container -->
<p-toast></p-toast>

<!-- Persistent Error Display -->
<app-persistent-error-display></app-persistent-error-display>

<!-- Global Loading Overlay -->
<div *ngIf="(isGlobalLoading$ | async)" class="fixed inset-0 bg-white/80 flex items-center justify-center z-[10000]">
    <p-progressSpinner 
        [style]="{'width': '48px', 'height': '48px'}" 
        strokeWidth="3"
        fill="transparent" 
        animationDuration="1s">
    </p-progressSpinner>
    
  </div>